<template>
	<div class="template table" v-show="dataVal.IsShow || dataVal.IsShow == null">
		<div>
			<div class="title">
				{{ dataVal.Property.Title[0].Text
				}}<span v-show="dataVal.deleteIsShow" @click="deleteTable(dataVal.Property.Title[0].Text)">删除</span>
			</div>
			<div v-for="(item, index) in dataVal.Config.Table.Children" :key="index">
				<Digit v-if="item.Property.Control == 'Number'" @child-event="getNumVal" :data-val="item"></Digit>
				<Percentage v-if="item.Property.Control == 'Percentage'" @child-event="getNumVal" :data-val="item">
				</Percentage>
				<Contact v-if="item.Property.Control == 'Condition'" :data-val="item"></Contact>
				<Date v-if="item.Property.Control == 'Date'" :data-val="item"></Date>
				<DateTime v-if="item.Property.Control == 'DateTime'" :data-val="item" @child-event="getDateTimeVal">
				</DateTime>
				<Version v-if="item.Property.Control == 'Text'" @child-event="getTextVal" :data-val="item"></Version>
				<Money v-if="item.Property.Control == 'Money'" @child-event="getNumVal" :data-val="item"></Money>
				<Tips v-if="item.Property.Control == 'Tips'" :data-val="item"></Tips>
				<File v-if="item.Property.Control == 'File'" :data-val="item"></File>
				<Selector v-if="item.Property.Control == 'Selector'" @child-event="getSelectorVal" :data-val="item">
				</Selector>
				<Textarea v-if="item.Property.Control == 'Textarea'" :data-val="item"></Textarea>
				<SelectFilterTable v-if="item.Property.Control == 'SelectFilterTable'" @child-event="getSelectorVal"
					:data-val="item" :template-data="templateData" :data-value="dataVal.Config.Table.Children">
				</SelectFilterTable>
				<Choose v-if="item.Property.Control == 'Contact'" @child-event="clickChoose" :data-val="item"></Choose>
			</div>
		</div>
		<div v-show="dataVal.addIsShow == null || dataVal.addIsShow" class="add-table"
			@click="addTable(dataVal.Property.Title[0].Text)">
			<span></span>
			添加明细
		</div>
	</div>
</template>

<script>
import Digit from "../components/Number.vue";
import Contact from "../components/Contact.vue";
import Date from "../components/Date.vue";
import DateTime from "../components/DateTime.vue";
import Version from "../components/Text.vue";
import Money from "../components/Money.vue";
import Tips from "../components/Tips.vue";
import File from "../components/File.vue";
import Selector from "../components/Selector.vue";
import Textarea from "../components/Textarea.vue";
import stringUtils from "../assets/js/stringUtil.js";
import SelectFilterTable from "../components/SelectFilterTable.vue";
import Choose from "../components/Choose.vue";
import Percentage from '../components/Percentage.vue';

import {
	getEmpInfoByEmpNo1
} from '@/api/employee'

export default {
	components: {
		Contact,
		Date,
		DateTime,
		Version,
		Money,
		Tips,
		File,
		Digit,
		Selector,
		Textarea,
		SelectFilterTable,
		Choose,
		Percentage,
	},
	props: ["dataVal", "templateData"],
	data() {
		return {};
	},
	created() {
		//页面挂载
		//console.log(this.dataVal)
		if (
			this.dataVal.Property.Title[0].Text.indexOf("信息中心技术鉴定") > -1 ||
			this.dataVal.Property.Title[0].Text.indexOf("申请内容") > -1 ||
			this.dataVal.Property.Title[0].Text.indexOf("供应商信息") > -1
		) {
			if (this.dataVal.addIsShow == true) {
				this.$set(this.dataVal, "addIsShow", stringUtils.getAddIsShow());
			}
		} else {
			if (stringUtils.getAddIsShow() !== null) {
				this.$set(this.dataVal, "addIsShow", stringUtils.getAddIsShow());
			}
		}
	},
	methods: {
		//方法
		clickChoose: async function (dataVal, name) {
			var that = this;
			if (that.dataVal.subCommission == true) {
				if (name == "部门数据填写人" || name == "请选择总经理") {
					this.sendTable(dataVal, "selectPeople");
				} else if (name == "请选择部门名称") {
					this.sendTable(dataVal, "selectDept");
				}
			} else {
				this.$emit("child-event", name, "selectChoose", dataVal);
			}
		},
		getTextVal(val, name) {
			if (name == "申请人工号") {
				this.dataVal.Config.Table.Children.forEach(m => {
					if (m.Property.Title[0].Text == '申请人姓名') {
						m.Value = ''
					}
					if (m.Property.Title[0].Text == '身份证号') {
						m.Value = ''
					}
				})
				if (val && val.length == 10) {
					getEmpInfoByEmpNo1(val).then(r => {
						if (r.ErrMsg == "success") {
							this.dataVal.Config.Table.Children.forEach(m => {
								if (m.Property.Title[0].Text == '申请人姓名') {
									m.Value = r.Body.EmpName
								}
								if (m.Property.Title[0].Text == '身份证号') {
									m.Value = r.Body.IdCard
								}
							})
						}
					})
				}
			}
		},
		getNumVal(val, name) {
			if (name == "数量" || name == "预计单价" || name == "单价") {
				var controlNum = this.dataVal.Config.Table.Children.filter((item) => {
					return item.Property.Title[0].Text == "数量";
				})[0];
				var controlPrice = this.dataVal.Config.Table.Children.filter((item) => {
					return item.Property.Title[0].Text == "预计单价";
				})[0];
				var sumPrice = 0.0;
				var sumAllPrice = 0.0;
				if (controlPrice == undefined) {
					controlPrice = this.dataVal.Config.Table.Children.filter((item) => {
						return item.Property.Title[0].Text == "单价";
					})[0];
					if (controlPrice == null) {
						return;
					}
					if (controlPrice.Value != null && controlPrice.Value.length > 0) {
						sumPrice = controlPrice.Value;
						if (controlPrice.Value != null && controlPrice.Value.length > 0) {
							if (controlNum.Value == "" || controlNum.Value == null) {
								controlNum.Value = 0;
							}
							sumPrice =
								parseFloat(controlNum.Value) * parseFloat(controlPrice.Value);
						}
					}
					var controlSum = this.dataVal.Config.Table.Children.filter((item) => {
						return item.Property.Title[0].Text == "小计";
					})[0];
					if (controlSum != null) {
						controlSum.Value = sumPrice.toFixed(2);
					}

					var tableList = this.templateData.TemplateContent.Controls.filter(
						(item) => {
							return item.Property.Control == "Table";
						}
					);
					tableList.forEach((table) => {
						table.Config.Table.Children.forEach((item) => {
							if (item.Property.Title[0].Text == "小计") {
								sumAllPrice += parseFloat(item.Value);
							}
						});
					});
					if (sumAllPrice >= 0) {
						// this.templateData.TemplateContent.Controls.filter(item=>{return item.Property.Title[0].Text=="合计"})[0].Value=sumAllPrice.toFixed(2).toString();
						let countControls = this.templateData.TemplateContent.Controls.filter(
							(item) => {
								return item.Property.Title[0].Text == "合计";
							}
						)[0];
						if (countControls != null) {
							countControls.Value = sumAllPrice.toFixed(2).toString();
						}
					}
				} else {
					if (controlPrice.Value != null && controlPrice.Value.length > 0) {
						sumPrice = controlPrice.Value;
						if (controlPrice.Value != null && controlPrice.Value.length > 0) {
							if (controlNum.Value == "" || controlNum.Value == null) {
								controlNum.Value = 0;
							}
							sumPrice =
								parseFloat(controlNum.Value) * parseFloat(controlPrice.Value);
						}
					}
					var controlSum = this.dataVal.Config.Table.Children.filter((item) => {
						return item.Property.Title[0].Text == "预计金额";
					})[0];
					controlSum.Value = sumPrice.toFixed(2);
					var tableList = this.templateData.TemplateContent.Controls.filter(
						(item) => {
							return item.Property.Control == "Table";
						}
					);
					tableList.forEach((table) => {
						table.Config.Table.Children.forEach((item) => {
							if (item.Property.Title[0].Text == "预计金额") {
								sumAllPrice += parseFloat(item.Value);
							}
						});
					});
					if (sumAllPrice >= 0) {
						let countControls = this.templateData.TemplateContent.Controls.filter(
							(item) => {
								return item.Property.Title[0].Text == "合计";
							}
						)[0];
						if (countControls != null) {
							countControls.Value = sumAllPrice.toFixed(2).toString();
						}
					}
				}
			} else if (name == "验收数量" || name == "验收单价") {
				var unitPrice = this.dataVal.Config.Table.Children.filter((item) => {
					return item.Property.Title[0].Text == "验收单价";
				})[0];
				var checkNum = this.dataVal.Config.Table.Children.filter((item) => {
					return item.Property.Title[0].Text == "验收数量";
				})[0];
				var sumPrice = 0.0;
				var sumAllPrice = 0.0;

				var unitPrice = this.dataVal.Config.Table.Children.filter((item) => {
					return item.Property.Title[0].Text == "验收单价";
				})[0];
				if (unitPrice.Value != null && unitPrice.Value.length > 0) {
					sumPrice = unitPrice.Value;
					if (unitPrice.Value != null && unitPrice.Value.length > 0) {
						sumPrice = parseFloat(checkNum.Value) * parseFloat(unitPrice.Value);
					}
				}
				var controlSum = this.dataVal.Config.Table.Children.filter((item) => {
					return item.Property.Title[0].Text == "验收小计";
				})[0];
				controlSum.Value = sumPrice.toFixed(2);
				var tableList = this.templateData.TemplateContent.Controls.filter(
					(item) => {
						return item.Property.Control == "Table";
					}
				);
				tableList.forEach((table) => {
					table.Config.Table.Children.forEach((item) => {
						if (item.Property.Title[0].Text == "验收小计") {
							sumAllPrice += parseFloat(item.Value);
						}
					});
				});
				if (sumAllPrice >= 0) {
					this.templateData.TemplateContent.Controls.filter((item) => {
						return item.Property.Title[0].Text == "实付金额";
					})[0].Value = sumAllPrice.toFixed(2).toString();
				}
			} else if (name == "小计") {
				this.computeTable(val);
			}
		},
		getSelectorVal(val, name) {
			var selectVal = "";
			var selectVal1 = "";
			var IsSealShow = true;
			var children = this.dataVal.Config.Table.Children;
			var i = 0;
			var j = 0;
			if (name == "公司") {
				if (val != null) {
					for (i = 0; i < children.length; i++) {
						children[i].Property.Require = 0;
					}
					for (i = 0; i < children.length; i++) {
						if (children[i].Property.Title[0].Text == "公司") {
							for (j = 0; j < children[i].Config.Selector.Options.length; j++) {
								if (val == children[i].Config.Selector.Options[j].Key) {
									selectVal =
										children[i].Config.Selector.Options[j].Value[0].Text;
									if (selectVal == "分行印章") {
										IsSealShow = false;
									}
									break;
								}
							}
						} else if (
							children[i].Property.Title[0].Text == "类型" ||
							children[i].Property.Title[0].Text == "印章类型"
						) {
							var options = children[i].Config.Selector.Options;
							//清空Select的值
							children[i].Values = [];
							children[i].ValuesSelect = [];

							if (selectVal == "四川中原物业顾问有限公司") {
								for (j = 0; j < options.length; j++) {
									if (
										options[j].Value[0].Text == "营业执照正本" ||
										options[j].Value[0].Text == "营业执照副本" ||
										options[j].Value[0].Text == "开户许可证" ||
										options[j].Value[0].Text ==
										"备案证书（房地产经纪咨询机构信息摘要）" ||
										options[j].Value[0].Text == "房地产经纪机构等级证书正本" ||
										options[j].Value[0].Text == "房地产经纪机构等级证书副本" ||
										options[j].Value[0].Text == "台港澳侨投资企业批准证书" ||
										options[j].Value[0].Text == "一般纳税人证明" ||
										options[j].Value[0].Text == "其他"
									) {
										options[j].IsShow = true;
									} else {
										options[j].IsShow = false;
									}
								}
							} else if (selectVal == "成都分公司") {
								for (j = 0; j < options.length; j++) {
									if (
										options[j].Value[0].Text == "营业执照正本" ||
										options[j].Value[0].Text == "营业执照副本" ||
										options[j].Value[0].Text ==
										"开户许可证（基本存款账户信息）" ||
										options[j].Value[0].Text ==
										"备案证书（房地产经纪咨询机构信息摘要）" ||
										options[j].Value[0].Text == "一般纳税人证明" ||
										options[j].Value[0].Text == "其他"
									) {
										options[j].IsShow = true;
									} else {
										options[j].IsShow = false;
									}
								}
							} else if (selectVal == "汇瀚") {
								for (j = 0; j < options.length; j++) {
									if (
										options[j].Value[0].Text == "营业执照正本" ||
										options[j].Value[0].Text == "营业执照副本" ||
										options[j].Value[0].Text == "开户许可证" ||
										options[j].Value[0].Text ==
										"备案证书（房地产经纪咨询机构信息摘要）" ||
										options[j].Value[0].Text == "一般纳税人证明" ||
										options[j].Value[0].Text == "台港澳侨投资企业批准证书" ||
										options[j].Value[0].Text == "章程" ||
										options[j].Value[0].Text == "其他"
									) {
										options[j].IsShow = true;
									} else {
										options[j].IsShow = false;
									}
								}
							} else if (selectVal == "房友圈") {
								for (j = 0; j < options.length; j++) {
									if (
										options[j].Value[0].Text == "营业执照正本" ||
										options[j].Value[0].Text == "营业执照副本" ||
										options[j].Value[0].Text ==
										"开户许可证（基本存款账户信息）" ||
										options[j].Value[0].Text ==
										"备案证书（房地产经纪咨询机构信息摘要）" ||
										options[j].Value[0].Text == "一般纳税人证明" ||
										options[j].Value[0].Text == "其他"
									) {
										options[j].IsShow = true;
									} else {
										options[j].IsShow = false;
									}
								}
							} else if (selectVal == "地产代理") {
								for (j = 0; j < options.length; j++) {
									if (
										options[j].Value[0].Text == "营业执照正本" ||
										options[j].Value[0].Text == "营业执照副本" ||
										options[j].Value[0].Text == "开户许可证" ||
										options[j].Value[0].Text ==
										"备案证书（房地产经纪咨询机构信息摘要）" ||
										options[j].Value[0].Text == "一般纳税人证明" ||
										options[j].Value[0].Text == "其他"
									) {
										options[j].IsShow = true;
									} else {
										options[j].IsShow = false;
									}
								}
							} else if (selectVal == "重庆港深汇房地产代理有限公司") {
								for (j = 0; j < options.length; j++) {
									if (
										options[j].Value[0].Text == "营业执照正本" ||
										options[j].Value[0].Text == "营业执照副本" ||
										options[j].Value[0].Text == "开户许可证" ||
										options[j].Value[0].Text == "一般纳税人证明" ||
										options[j].Value[0].Text == "其他"
									) {
										options[j].IsShow = true;
									} else {
										options[j].IsShow = false;
									}
								}
							} else if (selectVal == "四川原友信律师事务所") {
								for (j = 0; j < options.length; j++) {
									if (
										options[j].Value[0].Text == "营业执照正本" ||
										options[j].Value[0].Text == "营业执照副本" ||
										options[j].Value[0].Text == "开户许可证" ||
										options[j].Value[0].Text == "其他"
									) {
										options[j].IsShow = true;
									} else {
										options[j].IsShow = false;
									}
								}
							} else if (selectVal == "法人证件") {
								for (j = 0; j < options.length; j++) {
									if (
										options[j].Value[0].Text == "庄总身份证" ||
										options[j].Value[0].Text == "庄总通行证" ||
										options[j].Value[0].Text == "何总身份证" ||
										options[j].Value[0].Text == "何总通行证" ||
										options[j].Value[0].Text == "何总经纪人资格证书" ||
										options[j].Value[0].Text == "蒋燕身份证" ||
										options[j].Value[0].Text == "卢华身份证" ||
										options[j].Value[0].Text == "张耘身份证" ||
										options[j].Value[0].Text == "杨小玉身份证"
									) {
										options[j].IsShow = true;
									} else {
										options[j].IsShow = false;
									}
								}
							} else if (selectVal == "四川藤云网络科技有限公司") {
								for (j = 0; j < options.length; j++) {
									if (
										options[j].Value[0].Text == "营业执照正本" ||
										options[j].Value[0].Text == "营业执照副本" ||
										options[j].Value[0].Text == "开户许可证" ||
										options[j].Value[0].Text == "公章" ||
										options[j].Value[0].Text == "合同章" ||
										options[j].Value[0].Text == "成都市房地产经纪咨询机构摘要" ||
										options[j].Value[0].Text == "其他" ||
										options[j].Value[0].Text == "法人章"
									) {
										options[j].IsShow = true;
									} else {
										options[j].IsShow = false;
									}
								}
							}
							else if (selectVal === "分行") {
								for (j = 0; j < options.length; j++) {
									if (
										options[j].Value[0].Text == "开户许可证" ||
										options[j].Value[0].Text == "营业执照" ||
										options[j].Value[0].Text == "开票信息" ||
										options[j].Value[0].Text == "一般纳税人(税务事项通知书)"
									) {
										this.$set(options[j], "IsShow", true);
										// options[j].IsShow = true;
									} else {
										this.$set(options[j], "IsShow", false);
										// options[j].IsShow = false;
									}
								}
							}
							// if (selectVal == "分行") {
							// 	this.$set(children[i], "IsShow", false);
							// 	children[i].Value = "";
							// }
							else
								if (selectVal == "分行印章") {
									this.$set(children[i], "IsShow", false);
									children[i].Value = "";
								} else {
									children[i].Property.Require = 1;
									this.$set(children[i], "IsShow", true);
								}
							if (children[i].Property.Title[0].Text == "印章类型") {
								children[i].IsShow = IsSealShow;
								options.forEach((e) => {
									this.$set(e, "IsShow", true);
								})
							}
						}
						// else if (
						// 	children[i].Property.Title[0].Text.indexOf("备注") >= 0
						//     && selectVal == "分行"
						// ) {
						// 	children[i].Property.Require = 1;
						// 	children[i].Property.Placeholder[0].Text =
						// 		"申请人自行填写所需证件";
						// 	children[i].Value = "";
						// 	this.$set(children[i], "IsShow", true);
						// 	children[i].IsShow = true;
						// }
						else if (
							children[i].Property.Title[0].Text.indexOf("备注") >= 0 &&
							selectVal == "分行印章"
						) {
							children[i].Property.Require = 1;
							children[i].Property.Placeholder[0].Text =
								"申请人自行填写所需证件";
							children[i].Value = "";
							this.$set(children[i], "IsShow", true);
						} else if (children[i].Property.Title[0].Text == "备注") {
							children[i].Property.Placeholder[0].Text = "";
							this.$set(children[i], "IsShow", !IsSealShow);
							children[i].Value = "";
						}
					}
				}
			} else if (name == "类型") {
				var selectVal2 = "";
				if (val != null) {
					for (i = 0; i < children.length; i++) {
						if (children[i].Property.Title[0].Text == name) {
							for (j = 0; j < children[i].Config.Selector.Options.length; j++) {
								children[i].Values.forEach(async (item) => {
									if (item == children[i].Config.Selector.Options[j].Key) {
										selectVal1 +=
											children[i].Config.Selector.Options[j].Value[0].Text;
									}
								});
							}
						} else if (
							children[i].Property.Title[0].Text.indexOf("备注") >= 0
						) {
							if (selectVal1.indexOf("其他") > -1) {
								children[i].Property.Require = 1;
								this.$set(children[i], "IsShow", true);
								children[i].Value = "";
							} else {
								if (selectVal1 != null && selectVal1 != '') {
									this.$set(children[i], "IsShow", false);
									children[i].Property.Require = 0;
									children[i].Value = "";
								}
							}
						}
					}
				} else {
					for (i = 0; i < children.length; i++) {
						children[i].Property.Require = 0;
					}
				}
			}
			if (name === "水电物业费用缴纳" || name === "押金意见") {
				this.sendTable(val, name)
			}
			if (this.dataVal.Property.Title[0].Text === "配套设施") {
				this.sendTable(val, name)
			}
			switch (name) {
				case "seno":
					this.sendTable(val, "seno");
					break;
				case "clearEmp":
					this.sendTable(val, "clearEmp");
					break;
				case "clearHousename":
					this.sendTable(val, "clearHousename");
					break
				case "housename":
					this.sendTable(val, "housename");
					break
				case "exhibit":
					this.sendTable(val, "exhibit");
					break
				case "选择设备":
					this.sendTable(val, "articleNameSelect")
					break
				case "是否发函":
					this.sendTable(val, "是否发函")
					// var fhChild = children.filter(e => e.mark === "isFH")
					// if (fhChild.length > 0) this.sendTable(val,"是否发函")
					break
				case "是否法务起诉":
					this.sendTable(val, "是否法务起诉")
					break
				case "是否已开具发票":
					this.sendTable(val, "是否已开具发票")
					break
				case "是否当月已和甲方核对佣金":
					this.sendTable(val, "是否当月已和甲方核对佣金")
					break
				case "是否已发法务/律师函":
					this.sendTable(val, "是否已发法务/律师函")
					break
			}
			this.$forceUpdate();
		},
		deleteTable(val) {
			this.$emit("child-event", val, "delete", this.dataVal);
		},
		addTable(val) {
			this.$emit("child-event", val, "add", this.dataVal);
		},
		computeTable(val) {
			this.$emit("child-event", val, "compute", this.dataVal);
		},
		sendTable(val, type) {
			this.$emit("child-event", val, type, this.dataVal);
		},
		getDateTimeVal(val, type) {
			if (type === "资源借用") {
				this.$emit("child-event", val, type, this.dataVal)
			}
		}
	},
};
</script>

<style>
@import "../assets/css/common.css";

.table {
	border-bottom: 1px solid #eee;
	margin-top: 0;
}

.table .template {
	margin-top: 0;
	padding-left: 10px;
	padding-right: 6px;
}

.table .panel_wrap {
	padding: 10px 7px;
	border-bottom: 1px solid #eee;
}
</style>
